import React from 'react';
import { SignalGlyph } from '../SignalGlyph';
import { signals, signalsClosing } from '../../../data/signals';

/** Portrait print layout of the "What we learn" page. */
export function SignalsPdf() {
  return <div className="px-14" data-id="element-643" data-mp="nan3g59rs766">
      <header data-pdf-block data-id="element-644" data-mp="nadbwd92tryd">
        <span className="font-body text-[10px] uppercase tracking-[0.24em] text-[rgba(1,51,43,0.45)]" data-id="element-645" data-mp="s8okylrjryfj">
          Meet the Filteks · What we learn
        </span>
        <h1 className="mt-3 max-w-[20ch] font-heading text-[46px] leading-[1] tracking-[-0.03em] text-background" data-id="element-646" data-mp="3rpd6g49izyp6">
          Every interaction creates a signal.
        </h1>
      </header>

      <div className="mt-14 grid grid-cols-2 gap-x-12 gap-y-9" data-id="element-647" data-mp="4iasiu51vxkf">
        {signals.map(signal => <div key={signal.id} data-pdf-block className="flex items-start gap-4" data-id="element-648" data-mp="9akoorwrdtv5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-background ring-1 ring-[rgba(1,51,43,0.1)]" data-id="element-649" data-mp="37yrmkpcfa3zf">
              <SignalGlyph icon={signal.id} data-id="element-650" data-mp="3cwjdph58tm2k" />
            </span>
            <span className="pt-0.5" data-id="element-651" data-mp="3w4fjawacjby0">
              <span className="block font-heading text-[16px] leading-tight text-background" data-id="element-652" data-mp="3s3c4md41blyd">
                {signal.label}
              </span>
              <span className="mt-1.5 block max-w-[34ch] font-body text-[12.5px] leading-relaxed text-[rgba(1,51,43,0.55)]" data-id="element-653" data-mp="3nblsc1ljeo4b">
                {signal.detail}
              </span>
            </span>
          </div>)}
      </div>

      <p data-pdf-block className="mt-16 max-w-[38ch] border-t border-[rgba(1,51,43,0.14)] pt-10 font-heading text-[24px] leading-[1.18] tracking-[-0.02em] text-background" data-id="element-654" data-mp="3dccxz7mrf7hf">
        {signalsClosing}
      </p>
    </div>;
}